export default {
  setBrand: (state, value) => (state.data = { ...state.data, ...value }),
  resetBrand: (state) => (state.data = null)
}
